/**
 * 请求地址统一处理／组装
 * @param {*} actionName action方法名称
 */
export default function (actionName) {
  // 非生产环境 && 开启代理, 接口前缀统一使用[/proxyApi/]前缀做代理拦截!
  let url = 'http://s.lieguantech.com' // 正式环境
  // let url = 'http://172.16.0.9:8080' // 帅电脑
  // let url = 'http://localhost:8080'  // 部署服务器的本地接口
  return (process.env.NODE_ENV !== 'production' && process.env.OPEN_PROXY ? '/proxyApi/' : url) + actionName
}



// WEBPACK FOOTER //
// ./src/api/requestUrl.js